import React, { useState, useEffect, useRef} from 'react';
import { Table, Pagination, Modal } from 'antd';
import moment from 'moment';
import {useLocation } from 'react-router-dom';
import {CONST_PAGINATION_TEN} from '../../common/constants';
import { datadogRum } from '@datadog/browser-rum';
export default function CommonTable(props) {
  const { 
    columns,
    datasource,
    rowKey,
    showBordered,
    loadingData,
    triggerConditions,
    searchText,
    substituteItemSearch,
    onFecthData,
    onResetStore,
    expandedColumns,
    rowExpandable,
    expandedItemDataKey,
    paginationStyle,
    tableClassName,
    scrollStyle,
    paginationSetting,
    resetActivePagination,
    isdropout,
    isRefreshed,
    onOutsTableChange,
    isOgmSubsTable = false, //COT-9839
    sorting, //COT-1001,promote state to parent component
    requestApprovalFlag,
  } = props;
  const tableData = datasource?.data || [];
  const location = useLocation();
  const isSessionStorageSync = useRef(false); // Track when pagination update is from sessionStorage sync COT-10374

  const [pagination, setPagination] = useState(() => {
    const storedPageSize = parseInt(sessionStorage.getItem('pageSize'), 10);
    const storedPageIndex = parseInt(sessionStorage.getItem('pageIndex'), 10);
    return {
      pageIndex: storedPageIndex || CONST_PAGINATION_TEN.pageIndex,
      pageSize: storedPageSize || CONST_PAGINATION_TEN.pageSize,
      pageSizeOptions: CONST_PAGINATION_TEN.pageSizeOptions,
    };
  });

const getTableRowClassName = (record) => {
  const classes = [];

  if (record?.requestApprovalFlag) {
    classes.push('request-approval-row');
  }

  const expiredDate = record.endDate && moment().diff(moment(record.endDate), 'days');
  if (tableClassName === 'subs-report-table') {
    if (record.endDate && expiredDate < 1) {
      return classes.join(' ') || undefined;
    }
    if (record.endDate) {
      classes.push('greyed');
    }
  }

  return classes.join(' ') || undefined;
};

  // const [sorting, setSorting] = useState({sortedBy: null, sort: null}); //COT-1001,promote state to parent component
  useEffect(() => {
    const pageIndex = paginationSetting?.pageIndex ?? CONST_PAGINATION_TEN.pageIndex;
    const pageSize = paginationSetting?.pageSize ?? CONST_PAGINATION_TEN.pageSize;
    sessionStorage.setItem('pageIndex', pageIndex);
    sessionStorage.setItem('pageSize', pageSize);
    setPagination({
      pageIndex: parseInt(pageIndex, 10),
      pageSize: parseInt(pageSize, 10),
      pageSizeOptions: CONST_PAGINATION_TEN.pageSizeOptions,
    });

    onResetStore();    
  }, [paginationSetting,onResetStore]);
  useEffect(() => {
    if(triggerConditions !== undefined && triggerConditions !== null) {
      const storedPageIndex = parseInt(sessionStorage.getItem('pageIndex'), 10) || CONST_PAGINATION_TEN.pageIndex;
      const storedPageSize = parseInt(sessionStorage.getItem('pageSize'), 10) || CONST_PAGINATION_TEN.pageSize;
      
     isSessionStorageSync.current = true; // Mark as sessionStorage sync to prevent double API call COT-10374
      setPagination(prev => ({
        ...prev,
        pageIndex: storedPageIndex,
        pageSize: storedPageSize
      }));
      
      const formData = {
        ...triggerConditions, //this triggerConditions should be formatted formdata, not values saved in Form component
        pageIndex: storedPageIndex, //COT-10374
        pageSize: storedPageSize,
        ...sorting,
      }
      //for manage sub and outs
      /*COT-9839*/
      if(searchText) {
        if (isOgmSubsTable){
          const trimmed = searchText.trim();
          if (trimmed === '') {
            Modal.warning({
              title: 'Warning',
              content: 'Please enter a value to search.',
              okText: 'Ok',
              className: 'timeout-modal',
            });
            return;
          }
          if (/^\d+$/.test(trimmed)) {
            // Numeric input
            if (trimmed.length < 7){
              Modal.warning({
                title: 'Warning',
                content: 'Please enter 7 digits to search for Item Number.',
                okText: 'Ok',
                className: 'timeout-modal',
              });
              return;
            }
            formData.originalItem = searchText;
            delete formData.originalItemDescription;
          } else {
            // Alphabetic or mixed input
            if (trimmed.length < 3) {
              Modal.warning({
                title: 'Warning',
                content: 'Please enter at least 3 characters to search for Description.',
                okText: 'Ok',
                className: 'timeout-modal',
              });
              return; 
            }
            formData.originalItemDescription = searchText;
            delete formData.originalItem;
          }
        } else {
          // For non-ogmSubsTable, keep existing logic
          formData.originalItem = searchText;
          delete formData.originalItemDescription;
        }
      }
      if (substituteItemSearch) {
// COT-10047
        if (isOgmSubsTable) {
          const trimmed = substituteItemSearch.trim();
          if (trimmed === '') {
            Modal.warning({
              title: 'Warning',
              content: 'Please enter a value to search.',
              okText: 'Ok',
              className: 'timeout-modal',
            });
            return;
          }
          if (/^\d+$/.test(trimmed)) {
            // Numeric input
            if (trimmed.length < 7) {
              Modal.warning({
                title: 'Warning',
                content: 'Please enter 7 digits to search for Substitute Item Number.',
                okText: 'Ok',
                className: 'timeout-modal',
              });
              return;
            }
            formData.substituteItem = trimmed;
            if ('substituteItemDescription' in formData) delete formData.substituteItemDescription;
          } else {
            // Alphabetic or mixed input
            if (trimmed.length < 3) {
              Modal.warning({
                title: 'Warning',
                content: 'Please enter at least 3 characters to search for Description.',
                okText: 'Ok',
                className: 'timeout-modal',
              });
              return;
            }
            formData.substituteItemDescription = trimmed;
            if ('substituteItem' in formData) delete formData.substituteItem;
          }
        } else {
          // For non-ogmSubsTable, keep existing logic
          formData.substituteItem = substituteItemSearch;
          if ('substituteItemDescription' in formData) delete formData.substituteItemDescription;
        }
      }
      /*COT-9839*/
      // formData.optimizationEnable = optimizationEnable;    //COT-8330
      // formData.isPageChg = false
      const context = datadogRum.getGlobalContext('BosView');
      const timing = Date.now();
      onFecthData(formData).then((response) => {
      }).catch((err) => {
        if(err?.response && err?.response?.status && err?.response?.status === 504){
          Modal.warning({
            title: 'Warning',
            content: 'The request timed-out due large volume of data. Please narrow the search result and try again!',
            okText: 'Ok',
            // cancelText: 'Cancel',
            onOk: () => {},
            // onCancel: () =>{},
            className:'timeout-modal',
          });
        }
      });
      datadogRum.onReady(function(){
        datadogRum.addTiming(`Fetch ${context.BosView.screen} data`,timing);
      });
    }
  }, [triggerConditions, resetActivePagination, isdropout,isRefreshed]); // eslint-disable-line

  useEffect(() => {
    if (isSessionStorageSync.current) {
      isSessionStorageSync.current = false; // Reset flag //COT-10374
      return;
    }
    
    if(triggerConditions !== undefined && triggerConditions !== null) {
      const formData = {
        ...triggerConditions, //this triggerConditions should be formatted formdata, not values saved in Form component
        pageIndex: pagination.pageIndex,
        pageSize: pagination.pageSize,
        ...sorting,
      }
      /*COT-9839*/
      if (searchText) {
        if(isOgmSubsTable){
          const trimmed = searchText.trim();
          if (trimmed === '') {
            Modal.warning({
              title: 'Warning',
              content: 'Please enter a value to search.',
              okText: 'Ok',
              className: 'timeout-modal',
            });
            return;
          }
          if (/^\d+$/.test(trimmed)) {
            // Numeric input
            if (trimmed.length < 7){
              Modal.warning({
                title: 'Warning',
                content: 'Please enter 7 digits to search for Item Number.',
                okText: 'Ok',
                className: 'timeout-modal',
              });
              return;
            }
            formData.originalItem = searchText;
            delete formData.originalItemDescription;
          } else {
            // Alphabetic or mixed input
            if (trimmed.length < 3) {
              Modal.warning({
                title: 'Warning',
                content: 'Please enter at least 3 characters to search for Description.',
                okText: 'Ok',
                className: 'timeout-modal',
              });
              return; 
            }
            formData.originalItemDescription = searchText;
            delete formData.originalItem;
          }
        } else {
          // For non-ogmSubsTable, keep existing logic
          formData.originalItem = searchText;
          delete formData.originalItemDescription;
        }
// COT-10047
      }
      if (substituteItemSearch) {
        if (isOgmSubsTable) {
          const trimmed = substituteItemSearch.trim();
          if (trimmed === '') {
            Modal.warning({
              title: 'Warning',
              content: 'Please enter a value to search.',
              okText: 'Ok',
              className: 'timeout-modal',
            });
            return;
          }
          if (/^\d+$/.test(trimmed)) {
            // Numeric input
            if (trimmed.length < 7) {
              Modal.warning({
                title: 'Warning',
                content: 'Please enter 7 digits to search for Substitute Item Number.',
                okText: 'Ok',
                className: 'timeout-modal',
              });
              return;
            }
            formData.substituteItem = trimmed;
            if ('substituteItemDescription' in formData) delete formData.substituteItemDescription;
          } else {
            // Alphabetic or mixed input
            if (trimmed.length < 3) {
              Modal.warning({
                title: 'Warning',
                content: 'Please enter at least 3 characters to search for Description.',
                okText: 'Ok',
                className: 'timeout-modal',
              });
              return;
            }
            formData.substituteItemDescription = trimmed;
            if ('substituteItem' in formData) delete formData.substituteItem;
          }
        } else {
          // For non-ogmSubsTable, keep existing logic
          formData.substituteItem = substituteItemSearch;
          if ('substituteItemDescription' in formData) delete formData.substituteItemDescription;
        }
      }
      // formData.optimizationEnable = optimizationEnable; //COT-8330
      // formData.isPageChg = isPageChg
      const context = datadogRum.getGlobalContext('BosView');
      const timing = Date.now();
      onFecthData(formData).then((response) => {
      }).catch((err) => {
        if(err.response && err.response.status && err.response.status === 504){
          Modal.warning({
            title: 'Warning',
            content: 'The request timed-out due large volume of data. Please narrow the search result and try again!',
            okText: 'Ok',
            // cancelText: 'Cancel',
            onOk: () => {},
            // onCancel: () =>{},
            className:'timeout-modal',
          });
        }
      });
      datadogRum.onReady(function(){
        datadogRum.addTiming(`Fetch ${context.BosView.screen} data`,timing);
      });
    }
  }, [pagination.pageIndex, pagination.pageSize, sorting?.sortedBy, sorting?.sort]); // eslint-disable-line

  const totalRecords = datasource?.totals ?? 0; 
const currentPageIndex = pagination.pageIndex; 

useEffect(() => {
  if (tableData.length === 0 && currentPageIndex > 1 && totalRecords > 0) {
    // This is an automatic reset, not sessionStorage sync
    isSessionStorageSync.current = false; //COT-10374
    setPagination((prev) => {
      const updated = {
        ...prev,
        pageIndex: 1,
        pageSizeOptions: CONST_PAGINATION_TEN.pageSizeOptions,
      };
      sessionStorage.setItem('pageIndex', '1');
      sessionStorage.setItem('pageSize', `${prev.pageSize}`);
      return updated;
    });
  }
}, [tableData.length, currentPageIndex, totalRecords]);
  

  const expandedRowRender = (record, index) => {
    return (
      <Table 
        rowKey={record => `${record.substituteItem} - ${index}`}
        className="expanded-report-table" 
        columns={expandedColumns || []} 
        dataSource={record[expandedItemDataKey]} 
        pagination={false}
        rowClassName={(record, index) => {
          const expiredDate = record.endDate && moment().diff(moment(record.endDate), 'days'); 
          if(tableClassName === 'subs-report-table'){
            if(record.endDate && expiredDate < 1){
              return
            }else if(record.endDate) {
              return 'greyed'
            }
          }
        }}
      />
    );
  }
  //COT-10012,Customerized sorting, will not use table change function
  const onTableChange = (page, filters, sorter) => {
    if(onOutsTableChange) {
      onOutsTableChange(page, filters, sorter)
    }
    // setPageChg(false)
    //revert COT-9839'S  change as still use originalItem field to handle item description search
    const sort =
      Object.keys(sorter).length > 0 && sorter.order !== undefined
        ? {
            sortedBy: sorter.field,
            sort: sorter.order,
          }
        : {
          sortedBy: null,
          sort: null,
        };
    // This is sorting reset, not sessionStorage sync
    isSessionStorageSync.current = false; //COT-10374
    setPagination((prev) => ({
      ...prev,
      pageIndex: 1,
      pageSizeOptions: CONST_PAGINATION_TEN.pageSizeOptions,
    }));
    //setSorting(sort);
  };

  const onPaginationChange = (page, changedPageSize) => {
    const currPageIndex = pagination.pageSize !== changedPageSize ? 1 : page;

    sessionStorage.setItem('pageIndex', currPageIndex);
    sessionStorage.setItem('pageSize', changedPageSize);
  
    // This is normal user pagination, not sessionStorage sync
    isSessionStorageSync.current = false; //COT-10374
    setPagination({
      pageIndex: currPageIndex,
      pageSize: changedPageSize,
      pageSizeOptions: CONST_PAGINATION_TEN.pageSizeOptions,
    });
    let divElems = document.getElementsByClassName('ant-table-body')
    if(divElems.length > 0) {
      divElems[0].scrollTop = 0
    }
  };

  return (
    <div className="common-common-table">
      <Table
        rowKey={rowKey}
        className={`${tableClassName} common-report-table`}
        loading={loadingData}
        bordered={showBordered || false}
        columns={columns}
        expandedRowRender={expandedColumns === undefined ? null : record => expandedRowRender(record)}
        rowExpandable={rowExpandable === undefined ? null : record => rowExpandable(record)}
        dataSource={datasource && datasource.data}
        onChange={onTableChange}
        pagination={false}
        scroll={scrollStyle}
        // rowClassName={(record, index) => {
        //   const expiredDate = record.endDate && moment().diff(moment(record.endDate), 'days'); 
        //   if(tableClassName === 'subs-report-table'){
        //     if(record.endDate && expiredDate < 1){
        //       return
        //     }else if(record.endDate) {
        //       return 'greyed'
        //     }
        //   }
        // }}
         rowClassName={getTableRowClassName}
      />
      <Pagination
        key={`${pagination.pageIndex}-${pagination.pageSize}`} 
        style={paginationStyle}
        className={'report-pagination'}
        showSizeChanger
        current={pagination.pageIndex}
        pageSize={pagination.pageSize}
        total={datasource && datasource.totals}
        pageSizeOptions={pagination.pageSizeOptions}
        onShowSizeChange={onPaginationChange}
        onChange={onPaginationChange}
        disabled={datasource == null || datasource.data == null || datasource.data.length == 0}
      />
    </div>
  );
};
